import Cookies from 'js-cookie'

const TokenKey = 'bgdzh_token';
const UuidKey = 'bgdzh_uuid'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getUuid() {
    return Cookies.get(UuidKey)
}
export function setUuid(uuid) {
    return Cookies.set(UuidKey,uuid)
}
export function removeUuid() {
    return Cookies.remove(UuidKey)
}


// WEBPACK FOOTER //
// ./src/utils/auth.js